import React, { Component } from 'react';
import { css } from 'aphrodite/no-important';
import { styles } from './PageTitleStyles';

export default class PageTitle extends Component {
  render() {
    return (
      <div className={css(styles.pageTitle)}>
        <h2 className={css(styles.title)}>{this.props.title}</h2>
        <strong className={css(styles.subTitle)}>{this.props.subTitle}</strong>
      </div>
    );
  }
}
